export const translations = {
  en: {
    nav: {
      programs: "Programs",
      team: "Team",
      apply: "Apply Now",
      contact: "Contact",
      admin: "Admin",
    },
    hero: {
      title1: "ELITE MTB",
      title2: "ACADEMY",
      subtitle: "La Nucia, Spain",
      badge: "COMING SOON — 2027",
      tagline: "Where champions are forged. World-class mountain bike training meets academic excellence.",
      cta: "Register Your Interest",
      ctaSecondary: "Learn More",
    },
    about: {
      label: "About the Academy",
      title: "LIVE. LEARN. RIDE.",
      description: "LNMA is Europe's first residential mountain bike boarding school — a full-time, purpose-built environment where elite junior riders can train, compete, and earn a world-recognised academic qualification without compromise.",
      live: {
        title: "LIVE",
        text: "Full residential experience in La Nucia's Olympic Sports City. Mediterranean climate, world-class facilities, and a supportive community of like-minded athletes.",
      },
      learn: {
        title: "LEARN",
        text: "Accredited online schooling tailored to each rider — choose from USPA, Athlete Experience US (Scholarships USA) or King's InterHigh, plus other flexible platforms, all guided by an in-house academic advisor with in-person supervision on campus. NCAA-compliant US-diploma & scholarship routes, plus British qualifications. Flexible hours and full bilingual support.",
      },
      ride: {
        title: "RIDE",
        text: "Train year-round on UCI-sanctioned venues with expert coaches. From dirt jumps to alpine descents — every discipline, every terrain, every day.",
      },
    },
    programs: {
      label: "Disciplines",
      title: "FOUR DISCIPLINES. ONE ACADEMY.",
      clickHint: "Click to explore",
      facilities: "Facilities & Terrain",
      close: "Close",
      xc: {
        name: "Cross Country",
        desc: "Endurance, power, and technical precision on demanding XC circuits.",
        details: "Cross Country at LNMA is built around La Nucia's world-class infrastructure. Athletes train on the Camilo Cano UCI C1 XCO circuit — the same venue that hosts the Shimano Super Cup Massi — giving them race-day experience every training session.",
        facilitiesList: [
          "UCI XCO circuit (C1 category) — Camilo Cano Sports City",
          "La Nucia Bike Park & BTT trail network",
          "Velopark for technical skills",
          "Sierra Bernia ridge trails for endurance",
          "Altea & Calpe coastal trails",
          "Olympic-standard gymnasium & S&C programme",
          "Physiotherapy & sports medicine services",
          "Video analysis room with editing workstations"
        ],
      },
      downhill: {
        name: "Downhill",
        desc: "Speed, fearlessness, and split-second decisions on the steepest terrain.",
        details: "Our Downhill program leverages the dramatic terrain surrounding La Nucia. Riders progress from on-campus skill features to full-speed descents at La Fenasosa Bike Park and across the region's gravity trails.",
        facilitiesList: [
          "La Fenasosa Bike Park (30 min from campus)",
          "On-campus dirt jump park & progression zone",
          "Foam pit / airbag landing system for safe progression",
          "Covered mechanics workshop & bike storage",
          "Physiotherapy & sports medicine access",
          "Video analysis room for run breakdowns"
        ],
      },
      enduro: {
        name: "Enduro",
        desc: "The ultimate test of versatility — climb smart, descend fast.",
        details: "Enduro riders benefit from the most diverse terrain access of any academy in Europe. From the BTT network on campus to multi-day trips to Finale Ligure — home of the Enduro World Series — our riders see it all.",
        facilitiesList: [
          "La Nucia BTT trail network — daily access",
          "Sierra Bernia full-mountain terrain",
          "La Fenasosa Bike Park for weekend progression",
          "Altea & Calpe coastal trails",
          "Annual trip to Finale Ligure, Italy (EWS terrain)",
          "Dirt jump park & freeride progression zone",
          "Foam pit / airbag for trick development",
          "Olympic gym & sports medicine facilities"
        ],
      },
      freeride: {
        name: "Freeride",
        desc: "Push the boundaries of what's possible on two wheels.",
        details: "Freeride at LNMA is about pushing limits safely. Our purpose-built progression zone lets riders develop at their own pace, backed by foam pits and airbag systems. Seasonal trips to Grandvalira/Andorra add world-class slopestyle terrain.",
        facilitiesList: [
          "On-campus dirt jump park & freeride progression zone",
          "Graduated berms, jumps & drops (all difficulty levels)",
          "Foam pit / airbag landing system",
          "La Nucia Bike Park & Skate Park for cross-training",
          "La Fenasosa Bike Park for weekend sessions",
          "Seasonal trip to Grandvalira / Andorra",
          "BMX & trials bike zone for skill transfer",
          "Covered mechanics workshop",
          "Video analysis room for trick review"
        ],
      },
    },
    team: {
      label: "The Team",
      title: "MEET THE FOUNDERS",
      carlos: {
        name: "Carlos Coloma",
        role: "Co-Founder & Head Coach",
        bio: "Olympic Bronze Medalist (Rio 2016), 3x Olympian, Spanish National Champion, and one of the most decorated mountain bikers in Spanish history. With 23 career victories and over two decades of elite competition, Carlos brings unparalleled expertise and a vision to shape the next generation of champions.",
      },
      sebastian: {
        name: "Sebastian Sanchez",
        role: "Elite Amateur Athlete, Co-Founder & Entrepreneur",
        bio: "Elite amateur athlete, entrepreneur, and the driving force behind LNMA's business strategy. Sebastian combines his passion for mountain biking with sharp business acumen to build a world-class institution.",
      },
    },
    tuition: {
      label: "Tuition",
      title: "INVEST IN YOUR FUTURE",
      badge: "COMING SOON",
      subtitle: "A premium, world-class experience with limited spots available. Secure your place among the next generation of elite mountain bikers.",
      disclaimer: "Early access pricing — final rates may vary. All prices are subject to change as we finalize our inaugural program. Race travel is quoted separately per event. Opening is planned for 2027 and is subject to reaching our minimum inaugural enrolment.",
      limited: "Limited to 25 inaugural places",
      table: {
        program: "Program",
        duration: "Duration",
        price: "Price",
        includes: "Includes",
      },
      programs: [
        { program: "Full-Year Boarding", duration: "10 months", price: "€52,000", includes: "Tuition, board & coaching",
          details: [
            "Furnished room in sports village residence",
            "Full board catering (3 meals/day)",
            "Access to Olympic village facilities (gym, pool, physio)",
            "Choice of accredited online schools — USPA, Athlete Experience US or King's InterHigh (+ other flexible platforms) — with an in-house academic advisor and in-person teacher supervision",
            "4 specialist discipline coaching streams (XC, DH, Enduro, Freeride)",
            "Gym & S&C programme",
            "Life coach & wellbeing support",
            "Community events & team building",
            "Race competition preparation & coaching",
            "SMART goal & KPI tracking system"
          ],
          notIncluded: "Race travel costs (quoted separately per trip)"
        },
        { program: "Semester Boarding", duration: "5 months", price: "€28,000", includes: "Tuition, board & coaching",
          details: [
            "Furnished room in sports village residence",
            "Full board catering (3 meals/day)",
            "Access to Olympic village facilities (gym, pool, physio)",
            "Choice of accredited online schools — USPA, Athlete Experience US or King's InterHigh (+ other flexible platforms) — with an in-house academic advisor and in-person teacher supervision",
            "Discipline-specific coaching stream",
            "Gym & S&C programme",
            "Life coach & wellbeing support",
            "Race competition preparation"
          ],
          notIncluded: "Race travel costs (quoted separately per trip)"
        },
        { program: "Summer Camp Intensive", duration: "3 weeks", price: "€3,200", includes: "Coaching, board & meals",
          details: [
            "Accommodation in sports village",
            "Full board catering (3 meals/day)",
            "Discipline-specific intensive coaching",
            "Access to all campus training facilities",
            "Gym & S&C sessions",
            "Trail access across La Nucia network"
          ],
          notIncluded: "No academic programme included"
        },
        { program: "Day Rider Monthly", duration: "1 month", price: "€1,200", includes: "Coaching sessions only",
          details: [
            "Structured coaching sessions with LNMA coaches",
            "Access to campus training facilities during sessions",
            "Trail access across La Nucia network",
            "S&C guidance"
          ],
          notIncluded: "No accommodation, meals, or academic programme"
        },
      ],
      raceNote: "Race travel is not included in base tuition. Families receive transparent trip-by-trip pricing in advance for each event.",
      cta: "Apply Now",
    },
    admissions: {
      label: "Admissions",
      title: "THE SELECTION PROCESS",
      intro: "LNMA is a boarding school first — a place where young riders live, train, and study together full-time in La Nucia, Spain. We're looking for people who are as serious about their education as they are about their riding. This isn't just a bike camp. It's a structured, residential programme where academics and athletics carry equal weight.",
      limited: "Limited spots. For those ready to commit to both the bike and the books.",
      steps: [
        { number: "01", title: "Apply", desc: "Tell us about yourself — your riding background, your academic record, and what excites you about committing to a full-time boarding school experience at LNMA." },
        { number: "02", title: "Review", desc: "Our team reads every application personally. We look at who you are, your attitude toward both riding and learning, and whether you're ready for the demands of a residential academic-athletic programme." },
        { number: "03", title: "Interview", desc: "Shortlisted candidates have a conversation with our founders. We want to understand your motivation, your academic goals alongside your riding goals, and how serious you are about this commitment." },
        { number: "04", title: "Acceptance", desc: "Places go to those who show genuine passion and the willingness to invest in themselves — on the trail and in the classroom. Talent matters, but so does the drive to grow as a complete person." },
      ],
      whatWeLook: "What we look for",
      criteria: [
        "A real passion for mountain biking and the desire to live and breathe it every day",
        "Willingness to invest in yourself and commit to a full-time residential boarding school",
        "The right attitude — discipline, resilience, and openness to being coached",
        "Academic commitment — we expect you to take your education just as seriously as your riding. No exceptions.",
        "Readiness to live independently in a structured, supportive environment far from home",
      ],
      cta: "Start Your Application",
    },
    programme: {
      label: "The Programme",
      title: "A DAY AT LNMA",
      intro: "Every day at LNMA is designed around two priorities: serious academic progress and elite-level riding. Your day depends on your discipline — some riders train in the morning and study in the afternoon, others the reverse. Two typical patterns:",
      scheduleALabel: "SCHEDULE A — ACADEMICS FIRST",
      scheduleBLabel: "SCHEDULE B — TRAINING FIRST",
      scheduleA: [
        { time: "07:00 – 08:00", activity: "Wake-up, breakfast & equipment prep" },
        { time: "08:00 – 12:00", activity: "Academic session (your chosen online school + supervised classroom)" },
        { time: "12:00 – 13:00", activity: "Lunch & recovery" },
        { time: "13:00 – 17:30", activity: "MTB training session (discipline-specific coaching)" },
        { time: "17:30 – 18:30", activity: "Gym / S&C / supplementary skills" },
        { time: "18:30 – 19:30", activity: "Dinner" },
        { time: "19:30 – 21:00", activity: "Study period / goal review" },
        { time: "21:00 – 22:30", activity: "Free time, rest, lights-out" },
      ],
      scheduleB: [
        { time: "07:00 – 08:00", activity: "Wake-up, breakfast & equipment prep" },
        { time: "08:00 – 12:00", activity: "MTB training session (discipline-specific coaching)" },
        { time: "12:00 – 13:00", activity: "Lunch & recovery" },
        { time: "13:00 – 17:30", activity: "Academic session (your chosen online school + supervised classroom)" },
        { time: "17:30 – 18:30", activity: "Gym / S&C / supplementary skills" },
        { time: "18:30 – 19:30", activity: "Dinner" },
        { time: "19:30 – 21:00", activity: "Study period / goal review" },
        { time: "21:00 – 22:30", activity: "Free time, rest, lights-out" },
      ],
      travelTitle: "COMPETITION & TRAVEL",
      travelIntro: "Trips, events and racing are how riders grow. Our structured calendar takes students to the biggest events across Europe — from World Cup rounds to freeride festivals — all while maintaining academic continuity on the road.",
      travelEvents: [
        { event: "Shimano Super Cup Massi", location: "La Nucia (home race)", discipline: "XC" },
        { event: "UCI Mountain Bike World Cup", location: "Andorra, Val di Sole, Leogang", discipline: "XC / DH" },
        { event: "Enduro World Series (EWS)", location: "Finale Ligure, Tweed Valley, Loudenvielle", discipline: "Enduro" },
        { event: "iXS European Downhill Cup", location: "Multiple European rounds", discipline: "DH" },
        { event: "Spanish National Championship", location: "Spain", discipline: "All disciplines" },
        { event: "Junior European MTB Championships", location: "Europe", discipline: "XC / DH" },
        { event: "Red Bull / European Freeride Events", location: "Various", discipline: "Freeride" },
      ],
      travelNote: "Trips and events are organised through the year. When a trip is arranged, we set out its cost and share it with families at that point — there is nothing extra to budget in advance. Students travel with their own laptops to maintain academic continuity.",
    },
    forms: {
      studentTab: "Student",
      coachTab: "Coach / Teacher",
      investorTab: "Investor",
      student: {
        title: "Student Application",
        fullName: "Full Name",
        email: "Email",
        age: "Age",
        nationality: "Nationality",
        discipline: "Primary Discipline",
        experience: "Experience Level",
        whyFit: "Why do you think you would be a good fit for this school?",
        parentName: "Parent/Guardian Name",
        parentEmail: "Parent/Guardian Email",
        phone: "Phone Number",
        submit: "Submit Application",
        success: "Application submitted successfully! We'll be in touch.",
      },
      coach: {
        title: "Coach / Teacher Application",
        fullName: "Full Name",
        email: "Email",
        phone: "Phone Number",
        specialty: "Specialty / Discipline",
        experience: "Years of Experience",
        certifications: "Certifications",
        whyFit: "Why do you think you would be a good fit for this school?",
        resumeLink: "Resume / Portfolio Link",
        submit: "Submit Application",
        success: "Application submitted! We'll review your profile.",
      },
      investor: {
        title: "Investor Contact",
        fullName: "Full Name",
        email: "Email",
        phone: "Phone Number",
        company: "Company / Organization",
        interest: "Investment Interest Area",
        message: "Message",
        submit: "Send Message",
        success: "Message sent! Our team will reach out shortly.",
      },
      experienceLevels: {
        beginner: "Beginner",
        intermediate: "Intermediate",
        advanced: "Advanced",
        elite: "Elite / Competitive",
      },
      disciplines: {
        xc: "Cross Country (XC)",
        downhill: "Downhill (DH)",
        enduro: "Enduro",
        freeride: "Freeride",
      },
    },
    location: {
      label: "Location",
      title: "WHY LA NUCIA",
      intro: "La Nucia, on Spain's Costa Blanca, is home to one of Europe's most advanced sports complexes — and the perfect base for a residential MTB academy.",
      reasons: [
        { title: "300+ Days of Sunshine", desc: "True year-round outdoor training — no other European location offers this." },
        { title: "UCI C1 Race Venue", desc: "Students train on the Shimano Super Cup Massi circuit — where World Cup pros race." },
        { title: "Sports Village On-Site", desc: "Hotel-standard residence, catering & physio all within the Olympic complex." },
        { title: "45 min from ALC Airport", desc: "Direct European & international connections — global student access." },
        { title: "World-Class MTB Terrain", desc: "Puig Campana, Sierra Bernia, Aitana, La Fenasosa Bike Park (30 min) — XC to Freeride." },
        { title: "Government Land Access", desc: "Via Carlos Coloma — land & territory access granted by the Spanish government." },
      ],
    },
    footer: {
    },
  },
  es: {
    nav: {
      programs: "Programas",
      team: "Equipo",
      apply: "Aplica Ahora",
      contact: "Contacto",
      admin: "Admin",
    },
    hero: {
      title1: "ACADEMIA MTB",
      title2: "DE ELITE",
      subtitle: "La Nucia, Espana",
      badge: "PROXIMAMENTE — 2027",
      tagline: "Donde se forjan los campeones. Entrenamiento de mountain bike de clase mundial con excelencia academica.",
      cta: "Registra Tu Interes",
      ctaSecondary: "Saber Mas",
    },
    about: {
      label: "Sobre la Academia",
      title: "VIVE. APRENDE. RUEDA.",
      description: "LNMA es la primera escuela residencial de mountain bike en Europa — un entorno a tiempo completo, disenado especificamente donde ciclistas junior de elite pueden entrenar, competir y obtener una cualificacion academica reconocida mundialmente sin compromiso.",
      live: {
        title: "VIVE",
        text: "Experiencia residencial completa en la Ciudad Deportiva Olimpica de La Nucia. Clima mediterraneo, instalaciones de primer nivel y una comunidad de atletas con la misma pasion.",
      },
      learn: {
        title: "APRENDE",
        text: "Educacion online acreditada y personalizada para cada rider — elige entre USPA, Athlete Experience US (Scholarships USA) o King's InterHigh, ademas de otras plataformas flexibles, guiado por un asesor academico interno con supervision presencial en el campus. Vias de diploma y becas en EE. UU. conformes con la NCAA, ademas de titulaciones britanicas. Horarios flexibles y soporte totalmente bilingue.",
      },
      ride: {
        title: "RUEDA",
        text: "Entrena todo el ano en circuitos homologados por la UCI con entrenadores expertos. Desde dirt jumps hasta descensos alpinos, todas las disciplinas, todos los terrenos, todos los dias.",
      },
    },
    programs: {
      label: "Disciplinas",
      title: "CUATRO DISCIPLINAS. UNA ACADEMIA.",
      clickHint: "Haz clic para explorar",
      facilities: "Instalaciones y Terreno",
      close: "Cerrar",
      xc: {
        name: "Cross Country",
        desc: "Resistencia, potencia y precision tecnica en exigentes circuitos XC.",
        details: "El Cross Country en LNMA se construye sobre la infraestructura de clase mundial de La Nucia. Los atletas entrenan en el circuito UCI C1 XCO Camilo Cano — la misma sede del Shimano Super Cup Massi — viviendo la experiencia de competicion en cada sesion.",
        facilitiesList: [
          "Circuito UCI XCO (categoria C1) — Ciudad Deportiva Camilo Cano",
          "La Nucia Bike Park y red de senderos BTT",
          "Velopark para habilidades tecnicas",
          "Senderos de Sierra Bernia para resistencia",
          "Rutas costeras de Altea y Calpe",
          "Gimnasio olimpico y programa de S&C",
          "Fisioterapia y medicina deportiva",
          "Sala de video-analisis con estaciones de edicion"
        ],
      },
      downhill: {
        name: "Descenso",
        desc: "Velocidad, valentia y decisiones en fracciones de segundo en el terreno mas empinado.",
        details: "Nuestro programa de Descenso aprovecha el terreno dramatico que rodea La Nucia. Los riders progresan desde las instalaciones del campus hasta descensos a toda velocidad en La Fenasosa Bike Park y los senderos de gravedad de la region.",
        facilitiesList: [
          "La Fenasosa Bike Park (30 min del campus)",
          "Dirt jump park y zona de progresion en campus",
          "Foso de espuma / sistema de airbag para progresion segura",
          "Taller mecanico cubierto y almacen de bicis",
          "Fisioterapia y medicina deportiva",
          "Sala de video-analisis para revision de bajadas"
        ],
      },
      enduro: {
        name: "Enduro",
        desc: "La prueba definitiva de versatilidad: sube inteligente, baja rapido.",
        details: "Los riders de Enduro se benefician del acceso al terreno mas diverso de cualquier academia en Europa. Desde la red BTT del campus hasta viajes a Finale Ligure — sede del Enduro World Series — nuestros riders lo ven todo.",
        facilitiesList: [
          "Red de senderos BTT de La Nucia — acceso diario",
          "Terreno de montana completo en Sierra Bernia",
          "La Fenasosa Bike Park para progresion de fin de semana",
          "Rutas costeras de Altea y Calpe",
          "Viaje anual a Finale Ligure, Italia (terreno EWS)",
          "Dirt jump park y zona de progresion freeride",
          "Foso de espuma / airbag para desarrollo de trucos",
          "Gimnasio olimpico e instalaciones de medicina deportiva"
        ],
      },
      freeride: {
        name: "Freeride",
        desc: "Empuja los limites de lo posible sobre dos ruedas.",
        details: "El Freeride en LNMA trata de superar limites de forma segura. Nuestra zona de progresion permite a los riders desarrollarse a su ritmo, respaldados por fosos de espuma y sistemas de airbag. Viajes estacionales a Grandvalira/Andorra anaden terreno de slopestyle de clase mundial.",
        facilitiesList: [
          "Dirt jump park y zona de progresion freeride en campus",
          "Peraltes, saltos y drops graduados (todos los niveles)",
          "Foso de espuma / sistema de aterrizaje con airbag",
          "La Nucia Bike Park y Skate Park para entrenamiento cruzado",
          "La Fenasosa Bike Park para sesiones de fin de semana",
          "Viaje estacional a Grandvalira / Andorra",
          "Zona de BMX y trial para transferencia de habilidades",
          "Taller mecanico cubierto",
          "Sala de video-analisis para revision de trucos"
        ],
      },
    },
    team: {
      label: "El Equipo",
      title: "CONOCE A LOS FUNDADORES",
      carlos: {
        name: "Carlos Coloma",
        role: "Co-Fundador y Entrenador Principal",
        bio: "Medallista de Bronce Olimpico (Rio 2016), 3 veces Olimpico, Campeon Nacional de Espana y uno de los ciclistas de montana mas condecorados en la historia espanola. Con 23 victorias en su carrera y mas de dos decadas de competicion de elite, Carlos aporta una experiencia sin igual y la vision de formar la proxima generacion de campeones.",
      },
      sebastian: {
        name: "Sebastian Sanchez",
        role: "Atleta Amateur de Elite, Co-Fundador y Emprendedor",
        bio: "Atleta amateur de elite, emprendedor y la fuerza impulsora detras de la estrategia empresarial de LNMA. Sebastian combina su pasion por el mountain bike con una aguda vision empresarial para construir una institucion de clase mundial.",
      },
    },
    tuition: {
      label: "Matricula",
      title: "INVIERTE EN TU FUTURO",
      badge: "PROXIMAMENTE",
      subtitle: "Una experiencia premium de clase mundial con plazas limitadas. Asegura tu lugar entre la proxima generacion de ciclistas de montana de elite.",
      disclaimer: "Precios de acceso anticipado — las tarifas finales pueden variar. Todos los precios estan sujetos a cambios mientras finalizamos nuestro programa inaugural. Los viajes de competicion se cotizan por separado. La apertura esta prevista para 2027 y esta sujeta a alcanzar nuestra matriculacion inaugural minima.",
      limited: "Limitado a 25 plazas inaugurales",
      table: {
        program: "Programa",
        duration: "Duracion",
        price: "Precio",
        includes: "Incluye",
      },
      programs: [
        { program: "Internado Anual", duration: "10 meses", price: "€52,000", includes: "Matricula, alojamiento y coaching",
          details: [
            "Habitacion amueblada en la residencia de la villa deportiva",
            "Pension completa (3 comidas/dia)",
            "Acceso a instalaciones de la villa olimpica (gimnasio, piscina, fisio)",
            "Eleccion de escuelas online acreditadas — USPA, Athlete Experience US o King's InterHigh (+ otras) — con un asesor academico interno y supervision presencial",
            "4 vias de coaching por disciplina (XC, DH, Enduro, Freeride)",
            "Programa de gimnasio y S&C",
            "Life coach y apoyo al bienestar",
            "Eventos comunitarios y team building",
            "Preparacion y coaching para competiciones",
            "Sistema de seguimiento SMART goals y KPIs"
          ],
          notIncluded: "Costes de viaje de competicion (cotizados por separado)"
        },
        { program: "Internado Semestral", duration: "5 meses", price: "€28,000", includes: "Matricula, alojamiento y coaching",
          details: [
            "Habitacion amueblada en la residencia de la villa deportiva",
            "Pension completa (3 comidas/dia)",
            "Acceso a instalaciones de la villa olimpica (gimnasio, piscina, fisio)",
            "Eleccion de escuelas online acreditadas — USPA, Athlete Experience US o King's InterHigh (+ otras) — con un asesor academico interno y supervision presencial",
            "Coaching por disciplina especifica",
            "Programa de gimnasio y S&C",
            "Life coach y apoyo al bienestar",
            "Preparacion para competiciones"
          ],
          notIncluded: "Costes de viaje de competicion (cotizados por separado)"
        },
        { program: "Campamento de Verano", duration: "3 semanas", price: "€3,200", includes: "Coaching, alojamiento y comidas",
          details: [
            "Alojamiento en la villa deportiva",
            "Pension completa (3 comidas/dia)",
            "Coaching intensivo por disciplina",
            "Acceso a todas las instalaciones de entrenamiento",
            "Sesiones de gimnasio y S&C",
            "Acceso a la red de senderos de La Nucia"
          ],
          notIncluded: "No incluye programa academico"
        },
        { program: "Day Rider Mensual", duration: "1 mes", price: "€1,200", includes: "Solo sesiones de coaching",
          details: [
            "Sesiones de coaching estructuradas con entrenadores LNMA",
            "Acceso a instalaciones del campus durante sesiones",
            "Acceso a la red de senderos de La Nucia",
            "Orientacion en S&C"
          ],
          notIncluded: "Sin alojamiento, comidas ni programa academico"
        },
      ],
      raceNote: "Los viajes de competicion no estan incluidos en la matricula base. Las familias reciben precios transparentes viaje por viaje con antelacion para cada evento.",
      cta: "Aplica Ahora",
    },
    admissions: {
      label: "Admisiones",
      title: "EL PROCESO DE SELECCION",
      intro: "LNMA es ante todo una escuela residencial — un lugar donde jovenes riders viven, entrenan y estudian juntos a tiempo completo en La Nucia, Espana. Buscamos personas que se tomen su educacion tan en serio como su ciclismo. Esto no es solo un campamento de bicis. Es un programa residencial estructurado donde lo academico y lo deportivo tienen el mismo peso.",
      limited: "Plazas limitadas. Para quienes estan listos para comprometerse con la bici y los libros.",
      steps: [
        { number: "01", title: "Aplica", desc: "Cuentanos sobre ti — tu trayectoria ciclista, tu expediente academico y que te entusiasma de comprometerte con una experiencia de internado a tiempo completo en LNMA." },
        { number: "02", title: "Revision", desc: "Nuestro equipo lee cada solicitud personalmente. Buscamos quien eres, tu actitud hacia el ciclismo y el aprendizaje, y si estas preparado para las exigencias de un programa residencial academico-deportivo." },
        { number: "03", title: "Entrevista", desc: "Los candidatos preseleccionados tienen una conversacion con nuestros fundadores. Queremos entender tu motivacion, tus objetivos academicos junto a tus objetivos ciclistas, y lo serio que eres con este compromiso." },
        { number: "04", title: "Aceptacion", desc: "Las plazas son para quienes muestran verdadera pasion y la voluntad de invertir en si mismos — en el sendero y en el aula. El talento importa, pero tambien las ganas de crecer como persona completa." },
      ],
      whatWeLook: "Lo que buscamos",
      criteria: [
        "Una verdadera pasion por el mountain bike y el deseo de vivirlo y respirarlo cada dia",
        "Voluntad de invertir en ti mismo y comprometerte con un internado residencial a tiempo completo",
        "La actitud correcta — disciplina, resiliencia y apertura a ser entrenado",
        "Compromiso academico — esperamos que tomes tu educacion tan en serio como tu ciclismo. Sin excepciones.",
        "Disposicion a vivir de forma independiente en un entorno estructurado y de apoyo lejos de casa",
      ],
      cta: "Comienza Tu Solicitud",
    },
    programme: {
      label: "El Programa",
      title: "UN DIA EN LNMA",
      intro: "Cada dia en LNMA esta disenado en torno a dos prioridades: progreso academico serio y ciclismo de nivel elite. Tu dia depende de tu disciplina — algunos riders entrenan por la manana y estudian por la tarde, otros al reves. Dos patrones tipicos:",
      scheduleALabel: "HORARIO A — ACADEMICOS PRIMERO",
      scheduleBLabel: "HORARIO B — ENTRENAMIENTO PRIMERO",
      scheduleA: [
        { time: "07:00 – 08:00", activity: "Despertar, desayuno y preparacion del equipo" },
        { time: "08:00 – 12:00", activity: "Sesion academica (tu escuela online elegida + aula supervisada)" },
        { time: "12:00 – 13:00", activity: "Almuerzo y recuperacion" },
        { time: "13:00 – 17:30", activity: "Sesion de entrenamiento MTB (coaching por disciplina)" },
        { time: "17:30 – 18:30", activity: "Gimnasio / S&C / habilidades complementarias" },
        { time: "18:30 – 19:30", activity: "Cena" },
        { time: "19:30 – 21:00", activity: "Periodo de estudio / revision de objetivos" },
        { time: "21:00 – 22:30", activity: "Tiempo libre, descanso, luces apagadas" },
      ],
      scheduleB: [
        { time: "07:00 – 08:00", activity: "Despertar, desayuno y preparacion del equipo" },
        { time: "08:00 – 12:00", activity: "Sesion de entrenamiento MTB (coaching por disciplina)" },
        { time: "12:00 – 13:00", activity: "Almuerzo y recuperacion" },
        { time: "13:00 – 17:30", activity: "Sesion academica (tu escuela online elegida + aula supervisada)" },
        { time: "17:30 – 18:30", activity: "Gimnasio / S&C / habilidades complementarias" },
        { time: "18:30 – 19:30", activity: "Cena" },
        { time: "19:30 – 21:00", activity: "Periodo de estudio / revision de objetivos" },
        { time: "21:00 – 22:30", activity: "Tiempo libre, descanso, luces apagadas" },
      ],
      travelTitle: "COMPETICION Y VIAJES",
      travelIntro: "Los viajes, eventos y competiciones son como los riders crecen. Nuestro calendario estructurado lleva a los estudiantes a los eventos mas importantes de Europa — desde rondas de la Copa del Mundo hasta festivales de freeride — manteniendo la continuidad academica en el camino.",
      travelEvents: [
        { event: "Shimano Super Cup Massi", location: "La Nucia (carrera local)", discipline: "XC" },
        { event: "Copa del Mundo UCI MTB", location: "Andorra, Val di Sole, Leogang", discipline: "XC / DH" },
        { event: "Enduro World Series (EWS)", location: "Finale Ligure, Tweed Valley, Loudenvielle", discipline: "Enduro" },
        { event: "iXS European Downhill Cup", location: "Multiples rondas europeas", discipline: "DH" },
        { event: "Campeonato Nacional de Espana", location: "Espana", discipline: "Todas las disciplinas" },
        { event: "Campeonato Europeo Junior MTB", location: "Europa", discipline: "XC / DH" },
        { event: "Red Bull / Eventos Freeride Europeos", location: "Varios", discipline: "Freeride" },
      ],
      travelNote: "Los viajes y eventos se organizan a lo largo del ano. Cuando se organiza un viaje, se establece su coste y se comparte con las familias en ese momento — no hay nada extra que presupuestar por adelantado. Los estudiantes viajan con sus propios portatiles para mantener la continuidad academica.",
    },
    forms: {
      label: "Unete",
      title: "SE PARTE DE LA REVOLUCION",
      studentTab: "Estudiante",
      coachTab: "Entrenador / Profesor",
      investorTab: "Inversor",
      student: {
        title: "Solicitud de Estudiante",
        fullName: "Nombre Completo",
        email: "Correo Electronico",
        age: "Edad",
        nationality: "Nacionalidad",
        discipline: "Disciplina Principal",
        experience: "Nivel de Experiencia",
        whyFit: "Por que crees que serias un buen candidato para esta escuela?",
        parentName: "Nombre del Padre/Tutor",
        parentEmail: "Email del Padre/Tutor",
        phone: "Numero de Telefono",
        submit: "Enviar Solicitud",
        success: "Solicitud enviada con exito! Nos pondremos en contacto.",
      },
      coach: {
        title: "Solicitud de Entrenador / Profesor",
        fullName: "Nombre Completo",
        email: "Correo Electronico",
        phone: "Numero de Telefono",
        specialty: "Especialidad / Disciplina",
        experience: "Anos de Experiencia",
        certifications: "Certificaciones",
        whyFit: "Por que crees que serias un buen candidato para esta escuela?",
        resumeLink: "Enlace a CV / Portfolio",
        submit: "Enviar Solicitud",
        success: "Solicitud enviada! Revisaremos tu perfil.",
      },
      investor: {
        title: "Contacto de Inversor",
        fullName: "Nombre Completo",
        email: "Correo Electronico",
        phone: "Numero de Telefono",
        company: "Empresa / Organizacion",
        interest: "Area de Interes de Inversion",
        message: "Mensaje",
        submit: "Enviar Mensaje",
        success: "Mensaje enviado! Nuestro equipo se pondra en contacto pronto.",
      },
      experienceLevels: {
        beginner: "Principiante",
        intermediate: "Intermedio",
        advanced: "Avanzado",
        elite: "Elite / Competitivo",
      },
      disciplines: {
        xc: "Cross Country (XC)",
        downhill: "Descenso (DH)",
        enduro: "Enduro",
        freeride: "Freeride",
      },
    },
    location: {
      label: "Ubicacion",
      title: "POR QUE LA NUCIA",
      intro: "La Nucia, en la Costa Blanca de Espana, alberga uno de los complejos deportivos mas avanzados de Europa — y la base perfecta para una academia residencial de MTB.",
      reasons: [
        { title: "300+ Dias de Sol", desc: "Entrenamiento al aire libre durante todo el ano — ninguna otra ubicacion europea ofrece esto." },
        { title: "Sede UCI C1", desc: "Los estudiantes entrenan en el circuito Shimano Super Cup Massi — donde compiten los profesionales de la Copa del Mundo." },
        { title: "Villa Deportiva en el Campus", desc: "Residencia de estandar hotelero, catering y fisioterapia dentro del complejo olimpico." },
        { title: "45 min del Aeropuerto ALC", desc: "Conexiones directas europeas e internacionales — acceso global para estudiantes." },
        { title: "Terreno MTB de Clase Mundial", desc: "Puig Campana, Sierra Bernia, Aitana, La Fenasosa Bike Park (30 min) — de XC a Freeride." },
        { title: "Acceso a Terrenos del Gobierno", desc: "A traves de Carlos Coloma — acceso a tierras y territorio otorgado por el gobierno espanol." },
      ],
    },
    footer: {
      location: "La Nucia, Alicante, Espana",
      tagline: "El futuro del mountain bike empieza aqui.",
      rights: "Todos los derechos reservados.",
    },
  },
};
